export function DesktopMenuItem(props: {
  label: string;
  link: string;
  color?: string;
}) {
  return (
    <a href={props.link}>
      <div
        className="tw:text-base tw:font-semibold"
        style={{
          color: props.color ?? undefined,
        }}
      >
        {props.label}
      </div>
    </a>
  );
}
